import { useSelector } from "react-redux";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import { selectGlobalState } from "../../state-management/selectors";

const StackedBarChart = () => {
    const { newsData, articlesData, projectsData } =
        useSelector(selectGlobalState);

    const publishedArticles = articlesData.filter(
        (art: any) => art.is_active === true
    );
    const unpublishedArticles = articlesData.filter(
        (art: any) => art.is_active === false
    );
    const publishedNews = newsData.filter(
        (news: any) => news.is_active === true
    );
    const unpublishedNews = newsData.filter(
        (news: any) => news.is_active === false
    );
    const publishedProjects = projectsData.filter(
        (proj: any) => proj.is_active === true
    );
    const unpublishedProjects = projectsData.filter(
        (proj: any) => proj.is_active === false
    );

    const totalArticles = articlesData.length;
    const totalNews = newsData.length;
    const totalProjects = projectsData.length;

    const data = [
        {
            name: "مقالات",
            منتشرشده: publishedArticles.length,
            منتشرنشده: unpublishedArticles.length,
            کل: totalArticles,
        },
        {
            name: "اخبار",
            منتشرشده: publishedNews.length,
            منتشرنشده: unpublishedNews.length,
            کل: totalNews,
        },
        {
            name: "پروژه",
            منتشرشده: publishedProjects.length,
            منتشرنشده: unpublishedProjects.length,
            کل: totalProjects,
        },
    ];

    return (
        <div className="w-full h-[200px] max-w-[800px] mx-auto md:h-[250px]">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    barSize={50}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                    <XAxis dataKey="name" />
                    <Tooltip
                        contentStyle={{
                            border: "none",
                            color: "#000",
                        }}
                        cursor={{ fill: "none" }}
                    />
                    <Bar
                        dataKey="منتشرنشده"
                        stackId="a"
                        fill="#a0bd88"
                        opacity={0.6}
                    />
                    <Bar
                        dataKey="منتشرشده"
                        stackId="a"
                        fill="#81c26e"
                        opacity={0.6}
                    />
                    <Bar
                        dataKey="کل"
                        stackId="a"
                        fill="#2D667F"
                        opacity={0.6}
                        radius={[10, 10, 0, 0]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default StackedBarChart;
